import * as React from 'react';
const Home = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 17"
		fill="none"
		{...props}
	>
		<path d="M8 17v-6h4v6h5V9h3L10 0 0 9h3v8h5Z" />
	</svg>
);
export default Home;
